export const SPECIAL_OFFERS_DESKTOP_TEST_ID = 'home_special-offers_desktop';
export const SPECIAL_OFFERS_TABLET_TEST_ID = 'home_special-offers_tablet';
export const SPECIAL_OFFERS_MAX_CARD = 4;
export const SPECIAL_OFFERS_LG_COLS = 11;
export const MIN_INDEX_FOR_SECOND_ROW = 3;
